import React from 'react'
import {
  ModalContent,
  Header,
  Modal,
} from 'semantic-ui-react'
import logo from '../../images/bhmm-logo_black.jpeg'

const Infobox = (props) => {
  const [open, setOpen] = React.useState(true)

  const style = {
    headline: {
      color: '--var(--main-font-color-dark)',
      transform: 'rotate(-8deg)',
      fontSize: '100px',
      fontWeight: '300'
    },
    subline: {
      color: '--var(--main-font-color-dark)',
      fontFamily: 'Alfa Slab One',
      fontSize: '8vw',
      fontWeight: '300',
      lineHeight: '1'
    }
  }

  return (
    <Modal
      closeIcon
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    >
      <ModalContent>
        <div style={{ textAlign: 'center' }}>
          <img src={logo} alt="Logo" style={{ height: '110px', marginBottom: '20px' }} />
        </div>
        <div style={{ textAlign: 'center', padding: 30 }}>
          <h2 className={'headline-bag'} style={style.headline}>Save the<br />Date</h2>
        </div>
        <hr />
        <Header className={'headline-regular'} as='h1' style={{textAlign: 'center'}} >AB PALMSONNTAG 2025</Header>
        <p style={{fontSize: '24px'}} >
          Aus Abschied wird ein Neuanfang. Wir hatten da so eine Idee,
          eine Vision… Dazu gesellten sich Mumm, Planung,
          Entscheidungen, kompetente Partner, Freunde, konstantes
          Engagement, Zuverlässigkeit, Teamgeist, gute Verpflegung und
          natürlich die entsprechende Zeit. Und siehe da - nach vielen,
          schönen Jahren in der Stadtgasse haben wir die Chance
          genutzt, mehr Raum geschaffen, auf die Zukunft gebaut und
          voilà - ein neuer Häussler ist entstanden und freut sich nun
          munter belebt zu werden. Als ein Ort für Emotion, Genuss,
          Auszeit, Freizeit, Entspannung, Austausch und Begegnung. Als
          ein Ort für DICH und UNS gleichermaßen. An dem wir uns im
          Kontext qualitativer, handwerklicher Lebensmittel, Regionalität,
          Nachhaltigkeit oder auch einfach nur im Kontext einer guten
          Tasse Kaffee begrüßen können. Denn was immer Dich
          bewegt, vorbei zu schauen, ist unser täglicher Grund für Dich
          da zu sein - ganz HERZLICH WILLKOMMEN Auf der Wies 8.
        </p>
        <hr />
      </ModalContent>
    </Modal>)
}

export default Infobox